import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import { StrictMode } from "react";

import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";
import { BaseProvider } from "baseui";
import { Provider as StyletronProvider, DebugEngine } from "styletron-react";
import { Client as Styletron } from "styletron-engine-monolithic";
import { Provider } from "react-redux";
import { initialState } from "./app/redux/AppState";
import configureAppStore from "./app/configureStore";
import { lightTheme } from "./app/styles/AppTheme";
import { I18nextProvider } from "react-i18next";
import aws_config from "./aws-exports";
import configTranslation from "./translations/configi18n";
import { toaster, ToasterContainer } from "baseui/toast";
import { ErrorBoundary } from "react-error-boundary";
import MinWidthOverlay from "./app/components/min-width-overlay/MinWidthOverlay";
import { QueryClient, QueryClientProvider } from "react-query";
import { Amplify } from "aws-amplify";
import 'core-js/stable';
import 'regenerator-runtime/runtime';
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
Amplify.configure(aws_config);

const { store, persistor } = configureAppStore(initialState);
const queryClient = new QueryClient();

const debug =
  process.env.NODE_ENV === "production" ? void 0 : new DebugEngine();
const engine = new Styletron();

// Fallback component
const toasterOverrides = {
  ToastBody: {
    $style: ({ $theme }) => ({
      width: "500px", // Adjust this value as per your requirements
      maxWidth: "90%", // Optional: to ensure it doesn't get too large on smaller screens
    }),
  },
};
// REMOVE React Flow attribution (works for community edition)
const style = document.createElement("style");
style.innerHTML = `.react-flow__attribution { display: none !important; }`;
document.head.appendChild(style);


function ErrorFallback({ error }) {
  toaster.negative(`An error occurred: ${error.stack}`, {
    autoHideDuration: 50000,
  });
  return <div role="alert">An error occurred. Please try again.</div>;
}
// const THEME = {
//   light: 'light',
//   dark: 'dark',
// };
const i18next = configTranslation();
ReactDOM.render(
  <StrictMode>
    <StyletronProvider value={engine} debug={debug} debugAfterHydration>
      <BaseProvider theme={lightTheme}>
        <Provider store={store}>
          {/* <PersistGate loading={null} persistor={persistor}> */}
          <BrowserRouter basename={baseUrl}>
            <I18nextProvider i18n={i18next}>
              <ToasterContainer overrides={toasterOverrides}>
                <ErrorBoundary FallbackComponent={ErrorFallback}>
                  <QueryClientProvider client={queryClient}>
                    <MinWidthOverlay />
                    <App />
                  </QueryClientProvider>
                </ErrorBoundary>
              </ToasterContainer>
            </I18nextProvider>
          </BrowserRouter>
          {/* </PersistGate> */}
        </Provider>
      </BaseProvider>
    </StyletronProvider>
  </StrictMode>,
  rootElement
);

// Uncomment the line above that imports the registerServiceWorker function
// and the line below to register the generated service worker.
// By default create-react-app includes a service worker to improve the
// performance of the modeler by caching static assets. This service
// worker can interfere with the Identity UI, so it is
// disabled by default when Identity is being used.
//
//registerServiceWorker();
